import 'css-chunksrc/client/scenes/unavailabilityRemoval/styles.scss';export default {
  "planzoneResourceRemoval": "_planzoneResourceRemoval_nsoqg_1",
  "header": "_header_nsoqg_6",
  "group": "_group_nsoqg_10",
  "text": "_text_nsoqg_14",
  "main": "_main_nsoqg_19",
  "buttons": "_buttons_nsoqg_26"
};